/*
  Copyright (c) Epic Games, Inc. All Rights Reserved.
  CONTAINS AI GENERATED CODE. 
*/

"use client";

import useSWR from "swr";

import { useAccountStore } from "../account/account.hooks";

import { PriceRes, getPrice } from "./price.fetch";

export const usePrice = (
	locale: string,
	offerId: string,
	namespace: string,
	country: string,
): {
	price?: PriceRes;
	isLoading: boolean;
	error?: string;
} => {
	const { account, isLoading: accountLoading } = useAccountStore();
	const identityId = account?.id || "";

	const request = {
		locale,
		identityId,
		namespace,
		country,
		lineOffers: [
			{
				offerId,
				quantity: 1,
			},
		],
	};

	// without these, the price will not be fetched
	const shouldFetch = Boolean(locale && offerId && namespace && country);

	const { data, error } = useSWR(shouldFetch ? request : null, getPrice, {
		errorRetryCount: 1,
		revalidateOnFocus: false,
	});

	return {
		price: data,
		isLoading: shouldFetch && (accountLoading || (!data && !error)),
		error,
	};
};
